/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum LoaderSizes {
  SMALL = '17',
  DEFAULT = '25',
}
